
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacts/import",
      function () {
        return require("private-next-pages/contacts/import/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contacts/import"])
      });
    }
  